import { Link } from "react-router-dom";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

export const EditLinkStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "edit-link",
})`
  text-decoration: none;
  color: ${blueGreyMui._500};
  cursor: pointer;
`;

/** Same look and e2e identity as EditLinkStyled, but a real anchor — right-click gets the browser menu. */
export const EditLinkAnchorStyled = styled(Link).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "edit-link",
})`
  text-decoration: none;
  color: ${blueGreyMui._500};
  cursor: pointer;
`;
